import { createRender } from './types';
import { LeftNavCtaMessage } from '../../../common/components/LeftNavCtaMessage';
import { type Source } from '../../../common/types';

export const render = createRender(({ onDismissed, experimentCohort }) => {
	const context: {
		experimentCohort: string;
		source: Source;
	} = {
		experimentCohort,
		source: 'jira-side-nav',
	};

	return <LeftNavCtaMessage handleOnDismissed={onDismissed} context={context} />;
});

export default render;
